<template>
    <div class="scale-slider">
        <slider
            type="range"
            :value="objectScale"
            @input="scaleObject($event)"
            :min="0.1"
            :max="10"
            step="0.1"
            empty-rail="#F4F4F4"
            filled-rail="#6FD6BD"
        >
        </slider>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import Slider from '../shared/Slider';

export default {
    name: 'configure3DModelScaleSlider',
    data() {
        return {
            scale: null,
        };
    },
    components: {
        Slider,
    },
    computed: {
        ...mapGetters(['current3DFile', 'currentCartItem']),
        objectScale: {
            get() {
                return this.currentCartItem.scale;
            },
        },
    },
    methods: {
        scaleObject(value) {
            this.scale = Number(value);
            this.scaleObjectThrottled(this);
        },
        scaleObjectThrottled: _.throttle((vm) => {
            vm.$store.dispatch('updateCurrentCartItem', { scale: vm.scale });
        }, 50),
    },
};
</script>

<style scoped></style>
